import { useReducer, createContext, useContext, } from 'react'
import FlashMsgModal from '#Components/Modal'

const defaultModalProps = {
    bodyType: null,
    destination: null,
    showing: false,
    dialogClass: '',
    contentClass: '',
    size: null,
    customContent: null,
    callback: null,
}

const ModalContext = createContext();

export default function useModal() {
    return useContext(ModalContext)
}

export function ModalProvider({ children }) {
    // console.log('Modal Provider Render')
    const [modalProps, setModalProps] = useReducer(modalReducer, defaultModalProps)

    return (
        <ModalContext.Provider value={{
            setModalProps
        }}>
            {children}
            <FlashMsgModal {...{modalProps, setModalProps}}></FlashMsgModal>
        </ModalContext.Provider>
    )
}

//helpers
function modalReducer(oldProps, newProps) {
    if (!newProps) return { ...defaultModalProps }
    else return { ...oldProps, ...newProps }
}